import * as yup from 'yup';

const validationFields = {
  offeringId: yup.number().required('validations.bid.offering.required'),
  interestRate: yup
    .number()
    .typeError('validations.bid.interestRate.shouldBeNumber')
    .moreThan(0, 'validations.bid.interestRate.moreThanZero')
    .required('validations.bid.interestRate.required'),
  upfrontCharges: yup
    .number()
    .typeError('validations.bid.upfrontCharges.shouldBeNumber')
    .min(0, 'validations.bid.upfrontCharges.minimum')
    .required('validations.bid.upfrontCharges.required'),
  notes: yup.string(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = {
  offeringId: '',
  interestRate: '',
  upfrontCharges: '',
  notes: '',
};



// WEBPACK FOOTER //
// ./src/forms/bidForm.js